import { learnMoreModal as t } from './strings'

export const redCardBulletPoints = [
  t.bulletText1(),
  t.bulletText2(),
  t.bulletText3(),
  t.bulletText4(),
  t.bulletText5(),
]
